(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rrg-home-best-sellers"] && !Shopify.designMode) return;
  try {
    
  function initRrgBestSellers(root) {
    if (root.dataset.rrgReady === 'true') return;
    root.dataset.rrgReady = 'true';
    const tabs = Array.from(root.querySelectorAll('[data-rrg-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-rrg-category]'));
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const filter = tab.dataset.rrgFilter;
        root.classList.toggle('is-filtered', filter !== 'all');
        tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        cards.forEach((card) => { card.hidden = filter !== 'all' && card.dataset.rrgCategory !== filter; });
      });
    });
  }

  document.querySelectorAll('[data-rrg-bestsellers]').forEach(initRrgBestSellers);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-rrg-bestsellers]').forEach(initRrgBestSellers);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rrg-main-cart-footer"]) return;
  try {
    
  const mountRrgCartSummary = () => {
    const layout = document.querySelector('.rrg-cart__layout');
    const summary = document.getElementById('main-cart-footer');
    if (layout && summary && summary.parentElement !== layout) layout.appendChild(summary);
  };
  mountRrgCartSummary();
  document.addEventListener('shopify:section:load', mountRrgCartSummary);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rrg-main-cart-items"]) return;
  try {
    
  const installRrgCartRefresh = () => {
    customElements.whenDefined('cart-items').then(() => {
      const cartElement = document.querySelector('cart-items.rrg-cart');
      if (!cartElement || cartElement.dataset.rrgRefresh === 'true') return;
      cartElement.dataset.rrgRefresh = 'true';
      cartElement.onCartUpdate = function () {
        const itemsTarget = document.getElementById('main-cart-items');
        const footerTarget = document.getElementById('main-cart-footer');
        const requests = [];
        if (itemsTarget?.dataset.id) {
          requests.push(fetch(`${window.routes.cart_url}?section_id=${itemsTarget.dataset.id}`).then((response) => response.text()).then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const sourceCart = html.querySelector('cart-items.rrg-cart');
            const sourceItems = html.getElementById('main-cart-items');
            const sourceHeader = html.querySelector('.rrg-cart__header');
            if (sourceItems) itemsTarget.innerHTML = sourceItems.innerHTML;
            if (sourceHeader) this.querySelector('.rrg-cart__header').innerHTML = sourceHeader.innerHTML;
            this.classList.toggle('is-empty', sourceCart?.classList.contains('is-empty'));
          }));
        }
        if (footerTarget?.dataset.id) {
          requests.push(fetch(`${window.routes.cart_url}?section_id=${footerTarget.dataset.id}`).then((response) => response.text()).then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const sourceFooter = html.getElementById('main-cart-footer');
            const sourceContents = sourceFooter?.querySelector('.js-contents');
            const targetContents = footerTarget.querySelector('.js-contents');
            if (sourceContents && targetContents) targetContents.innerHTML = sourceContents.innerHTML;
            footerTarget.classList.toggle('is-empty', sourceFooter?.classList.contains('is-empty'));
          }));
        }
        return Promise.all(requests);
      };
    });
  };
  installRrgCartRefresh();
  document.addEventListener('shopify:section:load', installRrgCartRefresh);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rrg-main-collection"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-rrg-sort]');
    if (select) select.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rrg-main-product"]) return;
  try {
    
  const initRrgProduct = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const variants = JSON.parse(root.querySelector('[data-rrg-variants]')?.textContent || '[]');
    const form = root.querySelector('.rrg-product__form');
    const idInput = form?.querySelector('[data-rrg-variant-id]');
    const addButton = form?.querySelector('.rrg-product__add');
    const addLabel = form?.querySelector('[data-rrg-add-label]');
    const states = root.querySelector('[data-rrg-variant-states]');
    const addText = window.variantStrings?.addToCart || 'Add to cart';
    const soldOutText = window.variantStrings?.soldOut || 'Sold out';
    const unavailableText = window.variantStrings?.unavailable || 'Unavailable';

    const showMedia = (mediaId) => {
      if (!mediaId) return;
      const thumb = root.querySelector(`[data-rrg-thumb][data-media-id="${mediaId}"]`);
      if (thumb) thumb.click();
      root.querySelector(`.rrg-gallery__slide[data-media-id="${mediaId}"]`)?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    };

    const setVariant = (variant) => {
      const state = variant ? states?.querySelector(`[data-variant-id="${variant.id}"]`) : null;
      const available = state?.dataset.available === 'true';
      if (idInput) {
        idInput.value = variant?.id || '';
        idInput.disabled = !available;
      }
      if (addButton) {
        addButton.disabled = !available;
        addButton.setAttribute('aria-disabled', String(!available));
      }
      if (addLabel) addLabel.textContent = variant ? (available ? addText : soldOutText) : unavailableText;
      if (!state) return;
      const price = root.querySelector('[data-rrg-price]');
      const compare = root.querySelector('[data-rrg-compare]');
      const discount = root.querySelector('[data-rrg-discount]');
      const stickyPrice = root.querySelector('[data-rrg-sticky-price]');
      const stickyCompare = root.querySelector('[data-rrg-sticky-compare]');
      const sku = root.querySelector('[data-rrg-sku]');
      const skuRow = root.querySelector('[data-rrg-sku-row]');
      const quantity = form?.querySelector('[name="quantity"]');
      if (price) { price.textContent = state.dataset.price; price.classList.toggle('is-sale', Boolean(state.dataset.compare)); }
      if (stickyPrice) stickyPrice.textContent = state.dataset.price;
      if (compare) { compare.textContent = state.dataset.compare || ''; compare.hidden = !state.dataset.compare; }
      if (stickyCompare) { stickyCompare.textContent = state.dataset.compare || ''; stickyCompare.hidden = !state.dataset.compare; }
      if (discount) { discount.textContent = state.dataset.discount ? `-${state.dataset.discount}%` : ''; discount.hidden = !state.dataset.discount; }
      if (sku) sku.textContent = state.dataset.sku || '';
      if (skuRow) skuRow.hidden = !state.dataset.sku;
      if (quantity) {
        quantity.min = state.dataset.quantityMin || '1';
        quantity.step = state.dataset.quantityStep || '1';
        quantity.value = state.dataset.quantityMin || '1';
        if (state.dataset.quantityMax) quantity.max = state.dataset.quantityMax;
        else quantity.removeAttribute('max');
      }
      showMedia(state.dataset.mediaId);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    const updateOptionAvailability = () => {
      const groups = [...root.querySelectorAll('[data-rrg-option]')];
      const selected = groups.map((group) => group.querySelector('.is-selected')?.dataset.value);
      groups.forEach((group, groupIndex) => {
        group.querySelectorAll('button').forEach((candidate) => {
          const candidateAvailable = variants.some((variant) => variant.available && variant.options.every((value, optionIndex) => {
            if (optionIndex === groupIndex) return value === candidate.dataset.value;
            return !selected[optionIndex] || value === selected[optionIndex];
          }));
          candidate.disabled = !candidateAvailable;
        });
      });
    };

    root.querySelectorAll('[data-rrg-option] button').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-rrg-option]');
        group.querySelectorAll('button').forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        const label = group.querySelector('[data-rrg-selected-value]');
        if (label) label.textContent = button.dataset.value;
        const values = [...root.querySelectorAll('[data-rrg-option]')].map((option) => option.querySelector('.is-selected')?.dataset.value);
        setVariant(variants.find((variant) => variant.options.every((value, index) => value === values[index])));
        updateOptionAvailability();
      });
    });
    updateOptionAvailability();

    root.querySelectorAll('[data-rrg-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = thumb.dataset.rrgThumb;
        root.querySelectorAll('[data-rrg-thumb]').forEach((item) => { item.classList.remove('is-active'); item.removeAttribute('aria-current'); });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
        root.querySelectorAll('[data-rrg-media]').forEach((frame) => { frame.hidden = frame.dataset.rrgMedia !== index; frame.classList.toggle('is-active', frame.dataset.rrgMedia === index); });
      });
    });

    const mobileTrack = root.querySelector('.rrg-gallery__track');
    mobileTrack?.addEventListener('scroll', () => {
      const index = Math.min(root.querySelectorAll('.rrg-gallery__slide').length - 1, Math.round(Math.abs(mobileTrack.scrollLeft) / mobileTrack.clientWidth));
      root.querySelectorAll('.rrg-gallery__dots i').forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    }, { passive: true });

    const wishlist = root.querySelector('[data-rrg-wishlist]');
    const wishlistKey = `rrg-wishlist:${root.dataset.productHandle}`;
    try {
      const storedWishlist = localStorage.getItem(wishlistKey) === 'true';
      wishlist?.classList.toggle('is-active', storedWishlist);
      wishlist?.setAttribute('aria-pressed', String(storedWishlist));
    } catch (error) { /* storage can be unavailable */ }
    wishlist?.addEventListener('click', () => {
      const active = !wishlist.classList.contains('is-active');
      wishlist.classList.toggle('is-active', active);
      wishlist.setAttribute('aria-pressed', String(active));
      try { localStorage.setItem(wishlistKey, String(active)); } catch (error) { /* session-only fallback */ }
    });

    const sticky = root.querySelector('[data-rrg-sticky-bar]');
    const observer = new IntersectionObserver(([entry]) => sticky?.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
    if (addButton) observer.observe(addButton);
    root.querySelector('[data-rrg-sticky-add]')?.addEventListener('click', () => form?.requestSubmit(addButton));
  };
  document.querySelectorAll('[data-rrg-product]').forEach(initRrgProduct);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-rrg-product]').forEach(initRrgProduct));

  } catch(e) { console.error(e); }
})();
})();
